import React, { useState, useEffect, useRef } from "react";

import { useDispatch, useSelector, shallowEqual } from "react-redux";

import { numberWithCommas } from "../../../utils/helpers";

import {
  Table,
  Tooltip,
  Tag,
  Form,
  Input,
  Button,
  Space,
  Modal,
  Descriptions,
  Divider,
  Statistic,
  Col,
  Popconfirm,
  Collapse,
  Select,
  DatePicker,
  List,
  InputNumber,
  TimePicker,
  Checkbox,
  message,
} from "antd";
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  UserOutlined,
  VideoCameraOutlined,
  UploadOutlined,
  DeploymentUnitOutlined,
  SearchOutlined,
  EditOutlined,
  PlusOutlined,
  SaveOutlined,
  ShoppingCartOutlined,
  DeleteOutlined,
} from "@ant-design/icons";

import "./styles.scss";

import moment from "moment";
import {
  getData,
  editItem,
  addItem,
  deleteItem,
  updateItem,
} from "../../../Redux/actions/crudActions";
import { setPrice } from "../../../Redux/actions/productActions";
import {
  addCartItem,
  getCart,
  deleteCartItem,
  editCartItem,
  clearCart,
} from "../../../Redux/actions/cartActions";
import {
  createPackage,
  getPackageData,
  setPackage,
  deletePackagetItem,
  editPackageItem,
  attachSource,
  deleteByPackagesItembyProductID,
} from "../../../Redux/actions/packageActions";
import {
  setPurchaseOrder,
  updatePurchaseOrder,
  setSalesOrderPO,
  attachPurchaseItemSource,
} from "../../../Redux/actions/purchaseActions";

import { errorParser } from "../../../utils/helpers";

import CreateForm from "../../Generic/CreateForm";
import InputSelect from "../../Generic/InputSelect";
import ImageChecker from "../../Generic/ImageChecker";

import parse from "path-parse";

const { RangePicker } = DatePicker;
const { Panel } = Collapse;
const { Option } = Select;

const Index = ({
  purchaseItem,
  onCloseModal,
  onCancelmodal,
  mode,
  somethingchanged,
}) => {
  const dispatch = useDispatch();
  const { user, cart, crudData } = useSelector(
    (state) => ({
      user: state.auth.user,
      cart: state.cart.data,
      crudData: state.packages.data,
    }),
    shallowEqual
  );

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalWidth, setmodalWidth] = useState("80%");
  const [loading, setLoading] = useState(false);

  const [somethingChanged, setSomethingChanged] = useState(false);

  const [items, setItems] = useState([]);
  const [costTotal, setCostTotal] = useState(0);

  useEffect(() => {
    if (purchaseItem && purchaseItem !== []) {
      if (mode == "add") {
        setIsModalVisible(true);
        setItems(purchaseItem.items);
        var costTotalnew = 0;
        purchaseItem.items.map((xitem) => {
          if (parseFloat(xitem.tobuy) > 0) {
            costTotalnew =
              costTotalnew +
              parseFloat(xitem.cost_peso) * parseFloat(xitem.tobuy);
          }
        });

        setCostTotal(costTotalnew);
      }

      if (mode == "edit" && !Array.isArray(purchaseItem)) {
        if (purchaseItem.status == "toApprove") {
          attachingSource();
        } else {
          setIsModalVisible(true);
          setItems(purchaseItem.items);
          var costTotalnew = 0;
          purchaseItem.items.map((xitem) => {
            if (parseFloat(xitem.tobuy) > 0) {
              costTotalnew =
                costTotalnew +
                parseFloat(xitem.cost_peso_new) * parseFloat(xitem.tobuy);
            }
          });
          setCostTotal(costTotalnew);
        }
      }
    }
  }, [purchaseItem]);

  const attachingSource = async () => {
    var purchaseItems = await dispatch(
      attachPurchaseItemSource(purchaseItem.items)
    );
    setIsModalVisible(true);
    var total = 0;
    purchaseItems.map((it) => {
      console.log(parseFloat(it.tobuy), it);
      total = total + parseFloat(it.tobuy) * parseFloat(it.cost_peso);
    });
    total = total.toFixed(2);
    setItems(purchaseItems);
    setCostTotal(total);
  };

  const setthePurchaseOrder = async () => {
    setLoading(true);
    var POdata = {
      costTotal: costTotal,
      created_at: purchaseItem.created_at,
      created_by: purchaseItem.created_by,
      created_by_name: purchaseItem.created_by_name,
      created_for: purchaseItem.created_for,
      status: purchaseItem.status,
      updated_at: moment().format("YYYY-MM-DD HH:mm:ss"),
      items: items,
      package_list: purchaseItem.package_list,
    };

    if (mode == "add") {
      var purchaseID = await dispatch(setPurchaseOrder(POdata));
      var waitforthis = await dispatch(setSalesOrderPO(POdata, purchaseID));
      window.location.href = "/purchasing";
    }
    if (mode == "edit") {
      POdata["id"] = purchaseItem.id;
      var purchaseID = await dispatch(updatePurchaseOrder(POdata));
      onCloseModal();
      setIsModalVisible(false);
    }
    setLoading(false);
    console.log(POdata);
  };

  const cancelPurchase = async () => {
    setLoading(true);
    var POdata = {
      id: purchaseItem.id,
      status: "cancelled",
      package_list: purchaseItem.package_list,
      updated_at: moment().format("YYYY-MM-DD HH:mm:ss"),
    };
    var purchaseID = await dispatch(updatePurchaseOrder(POdata));
    var waitforthis = await dispatch(setSalesOrderPO(POdata, null));
    onCloseModal();
    setIsModalVisible(false);

    setLoading(false);
  };

  const footer = () => {
    if (
      purchaseItem &&
      (purchaseItem.status == "toApprove" || purchaseItem.status == "approved")
    ) {
      return (
        <div className="cartFooter">
          <div>
            <Button
              onClick={() => {
                summarycopy2();
              }}
              disabled={costTotal <= 0}
            >
              Copy To Clipboard
            </Button>
            <Button
              type={"primary"}
              onClick={() => {
                setthePurchaseOrder();
              }}
              disabled={costTotal <= 0}
            >{`${
              mode == "edit" ? "Save " : "Create "
            }Purchase Request Order`}</Button>
          </div>
          {mode == "edit" ? (
            <Popconfirm
              title="Are you sure to cancel this?"
              onConfirm={() => {
                cancelPurchase();
              }}
              okText="Yes"
              cancelText="No"
            >
              <Button type="danger" loading={loading}>
                Cancel
              </Button>
            </Popconfirm>
          ) : null}
        </div>
      );
    } else {
      return <div></div>;
    }
  };

  const summarycopy2 = () => {
    var copystring = "```" + "\r\n";
    copystring =
      copystring +
      `Good Afternoon po request lang po petty cash for tom. ` +
      "\r\n" +
      `${moment().add(1, "days").format("dddd, LL")} ` +
      "\r\n";
    copystring = copystring + `____________________` + "\r\n" + "\r\n";
    var costTotal = 0;
    items.map((xitem) => {
      if (parseFloat(xitem.tobuy) > 0) {
        costTotal =
          costTotal + parseFloat(xitem.cost_peso) * parseFloat(xitem.tobuy);
        copystring =
          copystring +
          `► ${xitem.product_name} - ${xitem.tobuy} ${xitem.unit}${
            xitem.tobuy > 1 ? "s" : ""
          }  (${(parseFloat(xitem.cost_peso) * parseFloat(xitem.tobuy)).toFixed(
            2
          )})` +
          "\r\n";
      }
    });

    copystring = copystring + `____________________` + "\r\n" + "\r\n";

    copystring = copystring + `Overall petty cash: ` + "\r\n";
    copystring = copystring + `${costTotal.toFixed(2)}` + "\r\n";
    copystring = copystring + "```";
    navigator.clipboard.writeText(copystring);
    message.success("message copied to clipboard");
  };

  const changeprice = (product, new_peso) => {
    if (new_peso) {
      var formbase = {
        cost_peso: parseFloat(new_peso).toFixed(2),
      };

      var newform = {
        ...formbase,
      };
      var newPrice = {
        ...formbase,
        created_at: moment().format("YYYY-MM-DD HH:mm:ss"),
      };

      dispatch(updateItem(newform, "products", product.id)).then((res) => {
        dispatch(setPrice(newPrice, product.id));
      });
    }
  };

  var deleteThissItem = async (record, index) => {
    setLoading(true);
    // console.log(record,index)
    var newitems = [...items];
    newitems.splice(index, 1);
    setItems(newitems);

    var costTotalnew = 0;
    newitems.map((xitem) => {
      if (parseFloat(xitem.tobuy) > 0) {
        costTotalnew =
          costTotalnew +
          parseFloat(xitem.cost_peso_new) * parseFloat(xitem.tobuy);
      }
    });

    var POdata = {
      id: purchaseItem.id,
      costTotal: costTotalnew,
      updated_at: moment().format("YYYY-MM-DD HH:mm:ss"),
      items: newitems,
    };
    var purchaseID = await dispatch(updatePurchaseOrder(POdata));
    var deleteinpackages = await dispatch(
      deleteByPackagesItembyProductID(purchaseItem.package_list, record.product)
    );

    setLoading(false);
    somethingchanged(true);
  };

  const renderlocal = (currentitems) => {
    var columns = [
      {
        title: "",
        render: (text, record, index) => {
          return (
            <ImageChecker
              url={`${process.env.REACT_APP_AWS_S3}${record.product}.png`}
              success={
                <img
                  src={`${process.env.REACT_APP_AWS_S3}${record.product}.png`}
                  alt="image"
                  className={"prodSummaryimage"}
                />
              }
              fail={
                <img
                  src={`${process.env.REACT_APP_AWS_S3}logo192.png`}
                  alt="image"
                  className={"prodSummaryimage"}
                />
              }
            />
          );
        },
      },
      {
        title: "name",
        dataIndex: "name",
        key: "name",
      },
      {
        title: "quantity",
        dataIndex: "quantity",
        key: "quantity",
        render: (text, record, index) => {
          return `${text} ${record.unit}`;
        },
      },
    ];

    if (
      user.role == "admin" ||
      user.role == "warehouse" ||
      user.role == "manager"
    ) {
      var tobuycolumn = [
        {
          title: "To Buy",
          dataIndex: "tobuy",
          key: "tobuy",
          render: (text, record, index) => {
            var tobuycomp = record.quantity;
            if (record[`${user.branch}_count`]) {
              if (
                parseFloat(record[`${user.branch}_count`]) <
                parseFloat(record.quantity)
              ) {
                tobuycomp =
                  parseFloat(record.quantity) -
                  parseFloat(record[`${user.branch}_count`]);
              } else {
                tobuycomp = 0;
              }
            }
            return (
              <InputNumber
                min={tobuycomp}
                defaultValue={parseFloat(text).toFixed(2)}
                onChange={(e) => {
                  var newlsit = [...items];
                  newlsit[index]["tobuy"] = e;
                  setItems(newlsit);
                }}
              />
            );
          },
        },
      ];

      if (
        user.role == "admin" ||
        user.role == "warehouse" ||
        user.role == "manager"
      ) {
        var actualcolumn = [
          {
            title: "actual quantity",

            render: (text, record, index) => {
              var tobuycomp = record.actual ?? record.tobuy;

              return (
                <div className="vertical">
                  {/* <span>actual: {record.tobuy }</span> */}
                  <InputNumber
                    min={0}
                    defaultValue={parseFloat(tobuycomp).toFixed(2)}
                    onChange={(e) => {
                      var newlsit = [...items];
                      newlsit[index]["actual"] = e;
                      setItems(newlsit);
                    }}
                  />
                </div>
              );
            },
          },
        ];
      }
      var stockcount = [
        {
          title: "in stock",
          className: "centercell",
          render: (text, record, index) => {
            var stockcount = 0;
            if (record[`${user.branch}_count`]) {
              stockcount = parseFloat(record[`${user.branch}_count`]);
            }
            return `${stockcount.toFixed(2)}`;
          },
        },
      ];
      if (purchaseItem) {
        if (
          purchaseItem.status == "toApprove" ||
          purchaseItem.status == "approved"
        ) {
          columns = columns.concat(stockcount);
        }
      }

      var costcolumn = [
        {
          title: "unit cost",
          dataIndex: "cost_peso_new",
          key: "cost_peso_new",
          render: (text, record, index) => {
            if (purchaseItem.status == "toApprove") {
              return (
                <InputNumber
                  min={0}
                  defaultValue={parseFloat(text).toFixed(2)}
                  onChange={(e) => {
                    var newlsit = [...items];
                    newlsit[index]["cost_peso_new"] = e;
                    setItems(newlsit);
                    changeprice(record, e);
                  }}
                />
              );
            } else {
              return text;
            }
          },
        },
      ];

      var actualbought = [
        {
          title: "actual",
          className: "centercell",
          render: (text, record, index) => {
            if (record.actual) {
              return record.actual;
            } else {
              return record.tobuy;
            }
          },
        },
      ];
      if (
        purchaseItem &&
        (purchaseItem.status == "completed" ||
          purchaseItem.status == "cancelled")
      ) {
        columns = columns.concat(actualbought);
      }

      if (
        purchaseItem &&
        (purchaseItem.status == "toApprove" ||
          purchaseItem.status == "approved")
      ) {
        if (purchaseItem.status == "toApprove") {
          columns = columns.concat(tobuycolumn);
        } else {
          columns = columns.concat(actualcolumn);
        }
        if (user.role !== "manager") {
          columns = columns.concat(costcolumn);
        }
      }

      var pricecolumn = [
        {
          title: "subtotal",
          render: (text, record, index) => {
            return `${numberWithCommas(
              (parseFloat(record.tobuy) * parseFloat(record.cost_peso)).toFixed(
                2
              )
            )} `;
            // if(purchaseItem && (purchaseItem.status == 'toApprove' || purchaseItem.status == 'approved') ){
            //   return(`${(parseFloat(record.tobuy) * parseFloat(record.cost_peso_new)).toFixed(2)} `)
            // }else{
            //   return(parseFloat(record.subtotal).toFixed(2) )
            // }
          },
        },
      ];
      if (user.role !== "manager") {
        columns = columns.concat(pricecolumn);
      }
      var deletecolumn = [
        {
          title: "delete",
          render: (text, record, index) => {
            return (
              <Popconfirm
                title="Are you sure to delete this Item?"
                onConfirm={() => {
                  deleteThissItem(record, index);
                }}
                okText="Yes"
                cancelText="No"
              >
                <Button type="danger" loading={loading}>
                  Delete
                </Button>
              </Popconfirm>
            );
          },
        },
      ];

      if (purchaseItem && purchaseItem.status == "toApprove") {
        columns = columns.concat(deletecolumn);
      }
    }

    var total = 0;

    items.map((i) => {
      if (purchaseItem?.status == "toApprove") {
        total = (
          parseFloat(total) +
          parseFloat(i.tobuy) * parseFloat(i.cost_peso)
        ).toFixed(2);
      } else {
        total = (
          parseFloat(total) +
          parseFloat(i.tobuy) * parseFloat(i.cost_peso_new)
        ).toFixed(2);
      }

      // if(purchaseItem && (purchaseItem.status == 'toApprove' || purchaseItem.status == 'approved' )){
      //   total =(parseFloat(total) + (parseFloat(i.tobuy) * parseFloat(i.cost_peso_new))).toFixed(2)
      // }else{
      //   total =(parseFloat(total) + parseFloat(i.subtotal)).toFixed(2)
      // }
    });
    // console.log(Items)

    return (
      <div className="summarylist">
        <Table
          columns={columns}
          dataSource={currentitems}
          pagination={false}
          size={"small"}
          rowClassName={(record) => {
            var tobuycomp = record.quantity;
            if (record.tobuy) {
              tobuycomp = record.tobuy;
            } else if (record[`${user.branch}_count`]) {
              if (
                parseFloat(record[`${user.branch}_count`]) <
                parseFloat(record.quantity)
              ) {
                tobuycomp =
                  parseFloat(record.quantity) -
                  parseFloat(record[`${user.branch}_count`]);
              } else {
                tobuycomp = 0;
              }
            }
            if (
              purchaseItem &&
              (purchaseItem.status == "pending" ||
                purchaseItem.status == "toPack")
            ) {
              if (tobuycomp > 0) {
                return "buythisrow";
              }
            }
          }}
        />
        {user.role == "admin" || user.role == "manager" ? (
          <div className="summaryfooter">
            <span className="oneline">
              <h2 className="bold">total: </h2>
              <h2>₱{numberWithCommas(total)}</h2>
            </span>
          </div>
        ) : null}
      </div>
    );
  };

  const closeModal = () => {
    if (!loading) {
      setItems([]);

      setIsModalVisible(false);
      if (somethingChanged) {
        onCloseModal();
        setSomethingChanged(false);
      }
    }
  };

  return (
    <>
      {/* <div className='packSummaryButton'>
        <Button onClick={()=>{getSummary()}} disabled={CurrentSelected == null || CurrentSelected.length < 1} type={'primary'} shape={'round'}>Get Summary</Button>
      </div> */}

      {isModalVisible ? (
        <Modal
          title={`Purchase Request Order for ${
            purchaseItem
              ? moment(purchaseItem.created_for, "YYYY-MM-DD HH:mm:ss").format(
                  "dddd, LL"
                )
              : ""
          }`}
          width={"auto"}
          visible={isModalVisible}
          footer={footer()}
          onCancel={() => {
            closeModal();
            onCancelmodal();
          }}
        >
          <div className="cart-content">
            {items && items.length > 0 ? renderlocal(items) : null}
            {purchaseItem && purchaseItem.package_list ? (
              <div className="vertical">
                <Divider orientation="left">Packages</Divider>
                {purchaseItem &&
                  purchaseItem.package_list.map((pk) => {
                    return (
                      <span>
                        {`${pk.destination_name} - ${pk.id}`}{" "}
                        {mode == "add" && pk.preexisting_request ? (
                          <span
                            style={{ color: "red" }}
                          >{` <-this package is already included in purchase order ${pk.preexisting_request} !! it will be ovewitten upon creation`}</span>
                        ) : (
                          ""
                        )}
                      </span>
                    );
                  })}
              </div>
            ) : null}
          </div>
        </Modal>
      ) : null}
    </>
  );
};

export default Index;
